module.exports = __webpack_public_path__ + "img/help-circle.a217347f.svg";